module.exports = __webpack_public_path__ + "static/img/choose-byself-01.8043387.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/assessment/choose-byself-01.jpg
// module id = 250
// module chunks = 1